import NifPassportInput from './NifPassportInput';

export default NifPassportInput;
